/** Persist list query so info "List" returns with filters. */
export const PURCHASE_LIST_SEARCH_KEY = "purchase-list-search";

export const getPurchaseListPath = () => {
  const q = sessionStorage.getItem(PURCHASE_LIST_SEARCH_KEY) || "";
  return `/purchase${q}`;
};

export const getPurchaseRowId = (record) =>
  record?.PurchaseNo ?? record?.purchase_no ?? record?.id;
